import Drift from 'drift-zoom';
import nodeArray from 'Carbon.Frontend/Resources/Private/Assets/Scripts/nodeArray';

const PANE_CONTAINER = document.querySelector('.drift-target');
const ELEMENTS = nodeArray('.drift-zoom');

setTimeout(() => {
    ELEMENTS.forEach((element) => {
        new Drift(element, {
            paneContainer: PANE_CONTAINER,
            inlinePane: 767,
            zoomFactor: 3,
            hoverBoundingBox: true,
            inlineOffsetY: -85,
            handleTouch: false,
        });
    });
}, 500);
